import { render } from "./ProductsChart.vue?vue&type=template&id=51b5310e&scoped=true"
import script from "./ProductsChart.vue?vue&type=script&lang=js"
export * from "./ProductsChart.vue?vue&type=script&lang=js"

import "./ProductsChart.vue?vue&type=style&index=0&id=51b5310e&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b5310e"]])

export default __exports__